import React from "react";
import styles from "./InTaxPaystubsTable.module.css";
import { moneyFmt } from "../../utils/deductions";
import { sumKV } from "../../utils/keyValue";

export default function InTaxPaystubsTable({ rows = [] }) {
  const hasRows = Array.isArray(rows) && rows.length > 0;

  if (!hasRows) {
    return (
      <div className={`pp-table is-comfortable ${styles.shell}`}>
        <div className="pp-table-scroll">
          <table className="table table-striped align-middle">
            <thead>
              <tr>
                <th data-col="md">Pay date</th>
                <th data-col="md">Period</th>
                <th className="is-num">Gross</th>
                <th className="is-num">Tax (withheld)</th>
                <th className="is-num">Other</th>
                <th className="is-num">Take-home</th>
                <th data-col="sm">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan={7}>
                  <div className="pp-table-empty">
                    No pay stubs yet.
                    <div className="small">Use “Add pay stub” to get started.</div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  return (
    <div className={`pp-table is-comfortable ${styles.shell}`}>
      <div className="pp-table-scroll">
        <table className="table table-striped align-middle">
          <thead>
            <tr>
              <th data-col="md">Pay date</th>
              <th data-col="md">Period</th>
              <th className="is-num">Gross</th>
              <th className="is-num">Tax (withheld)</th>
              <th className="is-num">Other</th>
              <th className="is-num">Take-home</th>
              <th data-col="sm">Actions</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => {
              const taxSum   = sumKV(r.taxes);
              const otherSum = sumKV(r.otherDeductions);
              const takeHome = r.takeHome ?? ((r.gross || 0) - taxSum - otherSum);

              return (
                <tr key={r.id || r.__rowId}>
                  <td>{r.payDate || "—"}</td>
                  <td className="truncate">{r.periodStart || "—"} → {r.periodEnd || "—"}</td>
                  <td className="is-num">{moneyFmt.format(r.gross || 0)}</td>
                  <td className="is-num">{moneyFmt.format(taxSum)}</td>
                  <td className="is-num">{moneyFmt.format(otherSum)}</td>
                  <td className="is-num">{moneyFmt.format(takeHome)}</td>
                  <td>
                    {/* actions placeholder */}
                    <div className="row-actions">
                      <button className="btn btn-sm btn-outline-secondary">Edit</button>
                      <button className="btn btn-sm btn-outline-danger">Delete</button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
